const NOTIFICATION_MESSAGE_URL = process.env.API_URL + '/xugarhero/notification/message';

const getMessages = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(NOTIFICATION_MESSAGE_URL)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const createMessage = (context, message) => {
  return new Promise((resolve, reject) => {
    context.$http.post(NOTIFICATION_MESSAGE_URL, message)
      .then(response => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

const updateMessage = (context, message) => {
  return new Promise((resolve, reject) => {
    context.$http.put(NOTIFICATION_MESSAGE_URL, message)
      .then(response => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

export default {
  getMessages,
  createMessage,
  updateMessage
};



// WEBPACK FOOTER //
// ./src/brand/health/api/notification/index.js